import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Topic from "../pages/topic/page";
import Community from "../pages/community/page";
import Rank from "../pages/rank/page";
import Booklist from "../pages/booklist/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topic",
    element: <Topic />,
  },
  {
    path: "/community",
    element: <Community />,
  },
  {
    path: "/rank",
    element: <Rank />,
  },
  {
    path: "/booklist",
    element: <Booklist />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;